import { useMemo } from 'react';
import { doc, DocumentReference, getFirestore } from 'firebase/firestore';
import { ReleaseState, RELEASE_STATE_COLLECTION, RELEASE_STATE_DOC_ID } from '@finvari/deliver';
import { useSubscribedDoc } from '../utils/firebaseHooks';

// The release backlog: what has landed on main and not yet reached the release branch. A single
// document the backend recomputes whenever either branch moves, so there is nothing to page through.
export function useReleaseState() {
  const docRef = useMemo(() => {
    const db = getFirestore();
    return doc(db, RELEASE_STATE_COLLECTION, RELEASE_STATE_DOC_ID) as DocumentReference<ReleaseState>;
  }, []);

  return useSubscribedDoc<ReleaseState, 'releaseState'>(docRef, 'releaseState');
}
